import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  :root{
    --bg: #0f1117;
    --surface: #161b26;
    --muted: #a6adbb;
    --text: #f7f9fb;
    --accent: #6b8cae;
    --accent-strong: #23ce6b;
    --border: rgba(255,255,255,0.08);
    --pill-bg: rgba(255,255,255,0.05);
    --shadow: 0 20px 70px rgba(0,0,0,0.35);
    --gradient: linear-gradient(135deg, rgba(107,140,174,0.22), rgba(35,206,107,0.18));
    scroll-behavior: smooth;
  }

  [data-theme='light']{
    --bg: #f7f8fb;
    --surface: #ffffff;
    --muted: #4b5563;
    --text: #0f141a;
    --border: rgba(15,20,26,0.08);
    --pill-bg: rgba(15,20,26,0.05);
    --shadow: 0 20px 50px rgba(15,20,26,0.08);
    --gradient: linear-gradient(135deg, rgba(107,140,174,0.14), rgba(35,206,107,0.16));
  }

  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html{
    font-size: 62.5%;
  }

  body{
    font-size: 1.6rem;
    -webkit-font-smoothing: antialiased;
    background-color: var(--bg);
    color: var(--text);
    font-family: 'Space Grotesk', 'Red Hat Display', system-ui, -apple-system, sans-serif;
    line-height: 1.6;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  ul, li {
    list-style: none;
    padding:0;
    margin: 0;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  body, input, textarea, button{
    font-family: 'Space Grotesk', 'Red Hat Display', system-ui, -apple-system, sans-serif;
    font-weight: 400;
  }

  button, .button{
    border: 1px solid var(--border);
    cursor: pointer;
    background: var(--gradient);
    color: var(--text);
    border-radius: 999px;
    font-weight: 600;
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease, background 0.2s ease;
    padding: 1.2rem 2.4rem;
    box-shadow: 0 10px 30px rgba(0,0,0,0.25);

    &:hover{
      transform: translateY(-2px);
      filter: brightness(1.05);
      box-shadow: 0 12px 36px rgba(0,0,0,0.3);
    }
  }

  button:disabled, .button:disabled{
    filter: brightness(0.85);
    cursor: not-allowed;
    box-shadow: none;
  }
`
